import React, {useState} from "react";
import CustomButton, {IconButton, OutlinedButton} from "../../../components/CustomButton";
import Input from "../../../components/form/Input";
import CustomModal from "../../../components/CustomModal";
import UnitSelector, {unit} from "./UnitSelector";
import {isInputFiledValid} from "../../../helpers/stringHelper";
import {isNaN} from "lodash/lang";
import {mapAndFilterUndefinedValues, mapAndParseObjectValueToNumberIfPossible} from "../../../helpers/objectHelper";

export const AddAreasModal = ({disabled, showModal, setShowModal, onAdd}) => {
  const initialAreas = [{
    max_shippable_weight: "",
    discount_percentage: "",
    price: {
      discounts: [{
        max: "1000", min: "0", discount_amt:"0"
      },],
      rate: ""
    },
    name: "",
    weight: {
      charges: [{
        max: "5", inc_factor: "0.5", unit: unit[0].value, rate: "55", min: "0"
      }],
      max_shipping_charge: "",
      weight_increment_threshold: ""
    }
  }]
  const [areas, setAreas] = useState(initialAreas)

  const isDiscountFormValid = (index) => {
    return areas[index].price.discounts.some((d) => !isInputFiledValid(d.min) || !isInputFiledValid(d.discount_amt));
  };

  const isChargeFormValid = (index) => {
    return areas[index].weight.charges.some((d) => !isInputFiledValid(d.min) || !isInputFiledValid(d.inc_factor) || !isInputFiledValid(d.unit) || !isInputFiledValid(d.rate) || !isInputFiledValid(d.max));
  };

  const isFormValid = () => {
    return areas.some((a) => !a.name || !a.max_shippable_weight || !a.price.rate || !a.weight.max_shipping_charge
      || !a.weight.weight_increment_threshold
      || a.weight.charges.some((d) => !isInputFiledValid(d.min) || !isInputFiledValid(d.inc_factor) || !isInputFiledValid(d.unit) || !isInputFiledValid(d.rate) || !isInputFiledValid(d.max))
      || a.price.discounts.some((d) => !isInputFiledValid(d.min) || !isInputFiledValid(d.discount_amt)))

  }

  const submitForm = (areas) => {
    let areaPayload = {
      max_shippable_weight: parseFloat(areas[0].max_shippable_weight),
      ...(areas[0].discount_percentage.length > 0 && {discount_percentage: parseFloat(areas[0].discount_percentage)}),
      name: areas[0].name,
      weight: {
        max_shipping_charge: parseFloat(areas[0].weight.max_shipping_charge),
        weight_increment_threshold: parseFloat(areas[0].weight.weight_increment_threshold),
        charges: mapAndParseObjectValueToNumberIfPossible(areas[0].weight.charges)
      },
      price: {
        rate:parseFloat(areas[0].price.rate),
        discounts: mapAndParseObjectValueToNumberIfPossible(mapAndFilterUndefinedValues(areas[0].price.discounts))
      }
    }
    onAdd([areaPayload])
  }

  const preventNegative = (e) => {
    if(e.keyCode === 189){
      e.preventDefault();
    }
  }

  return (
    <CustomModal title="Add Areas" loading={disabled} showModal={showModal} setShowModal={setShowModal}
                       button={<CustomButton
                         children="Submit"
                         disabled={isFormValid() || disabled}
                         onClick={() => submitForm(areas)}
                       />}>
    {areas.map((currentArea, areaIndex) => <div key={`areas${currentArea.id}-${areaIndex}`}>
      <div className="flex space-x-2">
        <Input label="Area *" value={currentArea.name} onChange={(e) => {
          currentArea.name = e.target.value;
          setAreas([...areas])
        }}
        />
        <Input label="Max Shippable Weight *" placeholder="Ex: 10" type="number"
               value={currentArea.max_shippable_weight}
               onChange={(e) => {
                 currentArea.max_shippable_weight = e.target.value
                 setAreas([...areas])
               }}
               onKeyDown={preventNegative}
        />
        <Input label="Discount Percentage" placeholder="Ex: 10" type="number"
               value={currentArea.discount_percentage}
               onChange={(e) => {
                 currentArea.discount_percentage = e.target.value
                 setAreas([...areas])
               }}
               onKeyDown={preventNegative}
        />
      </div>
      <div className="flex space-x-2">
        {/*price section*/}
        <div>
          <h1>Price</h1>
          <Input label="Rate *" placeholder="Ex: 10" value={currentArea.price?.rate}
                 onKeyDown={preventNegative}
                 onChange={(e) => {
            currentArea.price.rate = e.target.value
            setAreas([...areas])
          }}/>
          <p>Discounts</p>
          <div className="space-y-2">
            {currentArea.price?.discounts.map((d, index) => <div key={`discount-${index}`}
                                                                 className="relative p-4 pt-8 mb-4 border bg-secondary-100 rounded-md">
              {currentArea.price?.discounts.length > 1 && (<div className="absolute top-2 right-2">
                <IconButton
                  onClick={() => {
                    areas[areaIndex].price.discounts = currentArea.price?.discounts.filter((value) => value !== d)
                    setAreas([...areas])
                  }}
                />
              </div>)}
              <div className="flex space-x-2">
                <Input label="Min Amt *" value={d.min} onChange={(e) => {
                  d.min = e.target.value;
                  setAreas([...areas])
                }}
                       onKeyDown={preventNegative}
                />
                <Input label="Max Amt" value={d.max} onChange={(e) => {
                  d.max = e.target.value;
                  setAreas([...areas])
                }}
                       onKeyDown={preventNegative}
                />
                <Input label="Dis. Amt *" value={d.discount_amt} onChange={(e) => {
                  d.discount_amt = e.target.value;
                  setAreas([...areas])
                }}
                       onKeyDown={preventNegative}
                />
              </div>
            </div>)}
            {/*add more button*/}
            <div className="flex justify-end">
              <OutlinedButton
                disabled={isDiscountFormValid(areaIndex)}
                onClick={() => {
                  currentArea.price?.discounts.push({
                    min: "", max: "", discount_amt: '',
                  });
                  setAreas([...areas])
                }}
              >
                + Add more
              </OutlinedButton>
            </div>
          </div>
        </div>
        <div className="w-1 bg-gray-200"/>
        {/*weight section*/}
        <div>
          <h1>Weight</h1>
          <div className="flex space-x-2">
            <Input label="Max Shipping Charge *" placeholder="Ex: 10"
                   value={currentArea?.weight?.max_shipping_charge}
                   onChange={(e) => {
                     currentArea.weight.max_shipping_charge = e.target.value
                     setAreas([...areas])
                   }}
                   onKeyDown={preventNegative}
            />
            <Input label="Weight Increment Threshold *"
                   placeholder="Ex: 10"
                   value={currentArea?.weight?.weight_increment_threshold}
                   onChange={(e) => {
                     currentArea.weight.weight_increment_threshold = e.target.value
                     setAreas([...areas])
                   }}
                   onKeyDown={preventNegative}
            />
          </div>
          <p>Charges</p>
          <div className="space-y-2">
            {currentArea.weight?.charges.map((c, index) => <div key={`charges-${index}`}
                                                                className="relative p-4 pt-8 mb-4 border bg-secondary-100 rounded-md">
              {currentArea.weight?.charges.length > 1 && (<div className="absolute top-2 right-2">
                <IconButton
                  onClick={() => {
                    areas[areaIndex].weight.charges = currentArea.weight?.charges.filter((value) => value !== c);
                    setAreas([...areas])

                  }}

                />
              </div>)}
              <div className="flex space-x-2">
                <Input label="Min Weight *" value={c.min} onChange={(e) => {
                  c.min = e.target.value
                  setAreas([...areas])
                }}
                       onKeyDown={preventNegative}
                />
                <Input label="Max Weight *" value={c.max} onChange={(e) => {
                  c.max = e.target.value
                  setAreas([...areas])
                }}
                       onKeyDown={preventNegative}
                />
                <Input label="Rate *" value={c.rate} onChange={(e) => {
                  c.rate = e.target.value
                  setAreas([...areas])
                }}
                       onKeyDown={preventNegative}
                />
                <Input label="Inc factor *" value={c.inc_factor} onChange={(e) => {
                  c.inc_factor = e.target.value
                  setAreas([...areas])
                }}
                       onKeyDown={preventNegative}
                />
                <UnitSelector onChange={(e) => {
                  c.unit = e.value
                  setAreas([...areas])
                }} selectedUnit={c.unit}
                              onKeyDown={preventNegative}
                />
              </div>
            </div>)}
            <div className="flex justify-end">
              <OutlinedButton
                disabled={isChargeFormValid(areaIndex)}
                onClick={() => {
                  currentArea.weight?.charges.push({
                    min: "", max: "", rate: "", inc_factor: "", unit: unit[0].value,
                  });
                  setAreas([...areas]);
                }}
              >
                + Add more
              </OutlinedButton>
            </div>
          </div>
        </div>
      </div>
    </div>)}
  </CustomModal>)
}
